import { render, staticRenderFns } from "./PaymentMethodCardAddress.vue?vue&type=template&id=42c0aca0&scoped=true&"
import script from "./PaymentMethodCardAddress.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodCardAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c0aca0",
  null
  
)

/* custom blocks */
import block0 from "./PaymentMethodCardAddress.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./PaymentMethodCardAddress.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports